import React from 'react';

/**
 * EmptyState — empty / no-data placeholder.
 *
 * Props:
 *   icon: ReactNode (optional)
 *   title: string
 *   description: ReactNode (optional)
 *   action: ReactNode (optional — e.g. a Button)
 */
const EmptyState = ({ icon, title, description, action, className = '' }) => (
  <div className={`ps-empty ${className}`.trim()}>
    {icon && <span className="ps-empty__icon">{icon}</span>}
    {title && <p className="ps-empty__title">{title}</p>}
    {description && <p className="ps-empty__desc">{description}</p>}
    {action}
  </div>
);

export default EmptyState;
